import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import HomeIcon from '@mui/icons-material/Home';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ListAltIcon from '@mui/icons-material/ListAlt';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import TopNavBar from 'components/TopNavBar';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { drawerStyle } from './style';

Header.propTypes = {};
function Header(props) {
  const { t } = useTranslation();
  const [state, setState] = useState({
    left: false,
  });
  const [collapse, setCollapse] = useState(true);

  const handleMenuClick = (menu) => {
    setState({ state, left: menu });
  };

  const handleClick = () => {
    setCollapse(!collapse);
  };
  return (
    <Box>
      <TopNavBar onMenuClick={handleMenuClick}></TopNavBar>
      <Drawer open={state.left} onClose={() => setState({ state, left: false })}>
        <List component="nav" sx={{ ...drawerStyle }}>
          <ListItemButton>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText>
              <Link to="/"> {t('home')}</Link>
            </ListItemText>
          </ListItemButton>
          <ListItemButton onClick={handleClick}>
            <ListItemIcon>
              <Inventory2Icon />
            </ListItemIcon>
            <ListItemText>
              <Link to="/product"> {t('product')}</Link>
            </ListItemText>
            {collapse ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={collapse} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText>
                  <Link to="#"> Sim Data</Link>
                </ListItemText>
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText>
                  <Link to="#"> Sim Call Phone</Link>
                </ListItemText>
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText>
                  <Link to="#"> Handled Wifi</Link>
                </ListItemText>
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText>
                  <Link to="#"> Home Wifi</Link>
                </ListItemText>
              </ListItemButton>
            </List>
          </Collapse>
          <ListItemButton>
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText>
              <Link to="/prices"> {t('price')}</Link>
            </ListItemText>
          </ListItemButton>
          <ListItemButton>
            <ListItemIcon>
              <NewspaperIcon />
            </ListItemIcon>
            <ListItemText>
              <Link to="/news"> {t('news')}</Link>
            </ListItemText>
          </ListItemButton>
          <ListItemButton>
            <ListItemIcon>
              <SupportAgentIcon />
            </ListItemIcon>
            <ListItemText>
              <Link to="/contact"> {t('contact')}</Link>
            </ListItemText>
          </ListItemButton>
        </List>
      </Drawer>
    </Box>
  );
}

export default Header;
